import React from "react";

function RankPredictorHomePage() {
  return (
    <div className="my-space-tab-placeholder">
      <p className="my-space-tab-placeholder__title">Rank Predictor</p>
      <p className="my-space-tab-placeholder__text">
        This feature will be available soon.
      </p>
    </div>
  );
}

export default RankPredictorHomePage;
